import React from 'react';
import { humanizeISODate } from '../../../utils';
import { useLabResultContext } from './lab-result-provider';

interface RowProps {
  label: string
  value: string
}

const Row: React.FC<RowProps> = ({ label, value }: RowProps) => (
  <div className="flex flex-row py-2">
    <div className="flex-1">
      <h4 className="text-bold">{label}</h4>
    </div>
    <div className="flex-1">
      <p>{value}</p>
    </div>
  </div>
);

export const LabResultInfo: React.FC = () => {
  const { labResult } = useLabResultContext();

  return (
    <div className="shadow-lg rounded-lg p-8">
      {/* {error && <p className="py-2">{error}</p>} */}
      <Row label="Accession" value={labResult.accession} />
      <Row label="First Name" value={labResult.firstName} />
      <Row label="Last Name" value={labResult.lastName} />
      <Row label="Email" value={labResult.email} />
      <Row label="Original Order Date" value={labResult.originalOrderDate && humanizeISODate(labResult.originalOrderDate)} />
    </div>
  );
};
